import React, { useContext } from "react";
import { ThemeContext } from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";

import theme from "../../index.scss";
import ReactECharts from "echarts-for-react";

const MedicalBarChart = ({ data, userName, splitView }) => {
  const { t } = useTranslation();
  const { dark } = useContext(ThemeContext);

  const tSymptom = (factor) => {
    const categories = ["cognitive","sleep","emotional","physical","speech","vision"];
    const safe = (factor || "").trim().toLowerCase()
      .replace(/ /g,"_").replace(/\//g,"_").replace(/,/g,"")
      .replace(/:/g,"").replace(/'/g,"").replace(/[()]/g,"").replace(/-/g,"_")
      .substring(0, 60);
    for (const cat of categories) {
      const key = `symptom.${cat}.${safe}`;
      const translated = t(key);
      if (translated !== key) return translated;
    }
    return factor;
  };

  const result = [];
  const map = new Map();
  const medicalData = data?.filter((obj) => obj.symptom_id !== 53);

  medicalData.forEach((item) => {
    if (!map.has(item.factor)) {
      map.set(item.factor, { name: item.factor, value: 0, count: 0 });
    }
    const factor = map.get(item.factor);
    factor.value += item.severity;
    factor.count++;
  });

  map.forEach((value) => {
    value.value = (value.value / value.count).toFixed(1);
    result.push(value);
  });

  const sorted = result.sort((a, b) => b.value - a.value);
  const top5 = sorted.slice(0, 5);
  const allZeros = top5.every((item) => item.value === 0);

  const truncateText = (text, maxLength = 30) =>
    text.length > maxLength ? text.substring(0, maxLength) + "..." : text;

  const option = {
    title: {
      text: t("topsymptoms.title"),
      left: "center",
      textStyle: { fontSize: "1.2rem", color: dark ? theme.darkModeText : theme.black },
      subtext: allZeros
        ? t("notrackingdata.0")
        : `${splitView ? `(${userName})` : ""}`,
      subtextStyle: { fontSize: "1.3rem", color: dark ? theme.darkModeText : theme.primary },
    },
    tooltip: { trigger: "item" },
    xAxis: {
      type: "value",
      axisLabel: { fontSize: 16, color: dark ? theme.darkModeText : theme.black },
    },
    grid: { left: "5%", containLabel: true },
    yAxis: {
      type: "category",
      axisLabel: {
        fontSize: 16,
        color: dark ? theme.darkModeText : theme.black,
        formatter: (value) => truncateText(value),
      },
      data: top5.map((item) => tSymptom(item.name)).reverse(),
    },
    series: [{ data: top5.map((item) => item.value).reverse(), type: "bar" }],
  };

  return <ReactECharts option={option} style={{ minHeight: "25vh" }} />;
};

export default MedicalBarChart;